function CheckPureconnectAvailable() {
  try {
    if (typeof widgetAvailable === 'function' && widgetAvailable() === true) {
      var ele = document.getElementById('agent-chat')
      var classString = ele.className + ' ready'
      ele.className = classString
      clearInterval(pureconnectInterval)
    }
  } catch (err) {
    console.log(err)
  }
}

var pureconnectInterval = setInterval(function () {
  CheckPureconnectAvailable()
}, 1000)
setTimeout(function () {
  clearInterval(pureconnectInterval)
}, 15000)

document.addEventListener('click', function (e) {
  if (e.target.id == 'agent-chat') {
    if (e.target.className.contains('ready')) {
    } else {
      return false
    }
  }
})
